import ScrollToTopOnMount from '../../components/ScrollToTopOnMount/ScrollToTopOnMount';
const FindMetaMaskWithNFT = () => {
    return(
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20 mb-20 md:mb-36">
            <ScrollToTopOnMount />
            <div className="max-w-[1000px] mx-auto">
                <h1 className='mb-5 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                    How to Fund MetaMask with ETH
                </h1>
                <div className="flex flex-wrap mb-5">
                    <p className="m-3 text-sm sm:text-base text-gray-400 tracking-wider">
                        May 20, 2022
                    </p>
                    <p className="m-3 text-sm sm:text-base text-gray-400 tracking-wider">
                        <span className="text-gray-300">By </span> May 20, 2022
                    </p>
                    <p className="m-3 text-sm sm:text-base text-gray-400 tracking-wider">
                        Learn
                    </p>
                </div>

                <div className="w-full max-w-[600px] mx-auto mb-16">
                    <img src = 'https://images.unsplash.com/photo-1639781360241-dadbe5c28dce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2080&q=80' 
                        alt="wallet" className="w-full rounded-t-[8px]"/>
                </div>

                <p className="mb-8 text-sm sm:text-base text-gray-300 tracking-wider">
                    Now that your wallet is set up, you’ll need some ETH.
                </p>
                <p className="mb-8 text-sm sm:text-base text-gray-300 tracking-wider">
                    Ether is the native currency of the Ethereum network and it’s commonly abbreviated to ETH, which is its most common signifier. You need ETH to pay for some of your interactions with the blockchain, and to pay for the items you buy.
                </p>
                <p className="mb-8 text-sm sm:text-base text-gray-300 tracking-wider">
                    Here are two ways to easily fund your account: 
                </p>

                <h1 className='mb-5 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                    1) Buy Directly within MetaMask
                </h1>
                <p className="mb-8 text-sm sm:text-base text-gray-300 tracking-wider">
                    Depending on your region, you may be able to buy ETH directly with a credit or debit card via a third party provider. Please note, buying crypto with a credit card may incur additional fees, depending on which third-party provider you use. You may also not receive the entire crypto amount immediately.
                </p>

                <div className="pl-5 sm:pl-10 mb-16 sm:mb-20">
                    <ul className="list-decimal">
                        <li className="mb-5">
                            <p className="text-sm sm:text-base text-gray-300 tracking-wider">
                                Open the MetaMask wallet extension or the mobile app. 
                            </p>
                        </li>
                        <li className="mb-10">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                                Press <span className = 'font-[600] text-white'>Buy ETH.</span> 
                            </p>
                            <div className='w-full max-w-[700px] mx-auto'>
                                <img src = {require('../../assets/images/learn/fundmeta1.png')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>
                        <li className="mb-5">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                                Select a third-party service such as Wyre, Transak or MoonPay, which will facilitate the transfer of funds from your chosen funding source.
                            </p>
                            <div className='w-full max-w-[700px] mx-auto'>
                                <img src = {require('../../assets/images/learn/fundmeta2.gif')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>
                        <li className="mb-5">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                                Follow the steps provided by the third-party service. You may need to submit personal information like an ID card or proof of residence to meet KYC (Know Your Customer) requirements.
                            </p>
                        </li>
                        <li className="mb-5">
                            <p className="text-sm mb-5 sm:text-base text-gray-300 tracking-wider">
                                Once you’re finished purchasing, the funds should appear in your wallet.
                            </p>                    
                        </li>
                    </ul>
                </div>

                <h1 className='mb-5 secondary_heading leading-60px md:leading-60px 2xl:leading-84px text-lg sm:text-50px md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold '>
                    2) Funding From a Crypto Exchange
                </h1>
                <p className="mb-5 text-sm sm:text-base text-gray-300 tracking-wider">
                    It’s also easy to fund your wallet by depositing from a reputable crypto exchange, like <span className = 'text-[#DE00FF]'>FTX</span>, <span className = 'text-[#DE00FF]'>Coinbase</span> or <span className = 'text-[#DE00FF]'>Binance</span>, which offers a way to buy crypto with your bank account.
                </p>
                <p className="mb-5 text-sm sm:text-base text-gray-300 tracking-wider">
                    <span className = 'text-white font-[600]'>Handy tip:</span> You can use the FTX app to buy ETH and withdraw it to your MetaMask with no withdrawal fees (see example below).
                </p>

                <div className="pl-5 sm:pl-10 mb-16 sm:mb-20">
                    <div className='w-full max-w-[700px] mx-auto mb-5'>
                        <img src = {require('../../assets/images/learn/fundmeta3.gif')} alt = 'learn' className="w-full rounded-[8px]" />
                    </div>
                    <ul className="list-decimal">     
                        <li className="mb-5">
                            <p className="text-sm sm:text-base text-gray-300 tracking-wider">
                                Open the MetaMask wallet extension or the mobile app. 
                            </p>
                        </li>
                        <li className="mb-5">
                            <p className="mb-5 text-sm sm:text-base text-gray-300 tracking-wider">
                                Copy your wallet address by clicking the Account button with a clipboard icon. If you’re using the desktop wallet extension, a Copy to clipboard will appear when you hover your mouse over the address.
                            </p>
                            <div className='w-full max-w-[700px] mx-auto mb-5'>
                                <img src = {require('../../assets/images/learn/fundmeta4.webp')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>
                        <li className="mb-5">
                            <p className="mb-3 text-sm sm:text-base text-gray-300 tracking-wider">
                                Paste your wallet address as a ‘recipient address’ when withdrawing from your crypto exchange. You can also consult the FAQ for each exchange below. Please note that these are third parties and we cannot make any guarantees about their service.
                            </p>
                            <div className='flex flex-col'>
                                <a href = 'https://help.blockfolio.com/hc/en-us/articles/1260801656210-FTX-App-Trading-Withdrawals' target = '_blank' rel = 'noreferrer' className="mb-3 text-blue-300 text-sm sm:text-base text-gray-300 tracking-wider">
                                    - How to send crypto from FTX
                                </a>
                                <a href = 'https://help.coinbase.com/en/coinbase/trading-and-funding/cryptocurrency-trading-pairs/how-to-send-and-receive-cryptocurrency' target = '_blank' rel = 'noreferrer' className="mb-3 text-blue-300 text-sm sm:text-base text-gray-300 tracking-wider">
                                    - How to send crypto from Coinbase
                                </a>
                                <a href = 'https://www.binance.com/en/blog/p2p/how-to-send-crypto-to-family-and-friends-worldwide-using-binance-p2p-421499824684902082' target = '_blank' rel = 'noreferrer' className="mb-3 text-blue-300 text-sm sm:text-base text-gray-300 tracking-wider">
                                    - How to send crypto from Binance
                                </a>
                            </div>
                        </li>
                        <li className="mb-5">
                            <p className="mb-5 text-sm sm:text-base text-gray-300 tracking-wider">
                                It may take some time for the ETH to appear in your wallet. After processing your withdrawal, your crypto exchange should provide a number called a Transaction Hash or Transaction ID. This is a unique number for each transaction on the blockchain. You can use this unique number to check the progress of your withdrawal on third-party tools like 
                                <a href = 'https://etherscan.io/' target = '_blank' rel = 'noreferrer' className='text-blue-300'>Etherscan</a>.
                            </p>
                            <div className='w-full max-w-[700px] mx-auto mb-5'>
                                <img src = {require('../../assets/images/learn/fundmeta5.webp')} alt = 'learn' className="w-full rounded-[8px]" />
                            </div>
                        </li>
                    </ul>

                </div>

            </div>

        </div>
    )
}

export default FindMetaMaskWithNFT;